import { useState } from 'react';
import { toast } from 'sonner';
import { Github } from '@/components/icons';
import { Button } from '@/components/ui/button';

interface Props {
  callbackURL: string;
  errorCallbackURL: string;
  label: string;
}

// The GitHub button of the apply landing and of the invite landing, which were the same
// `authClient.signIn.social(...)` call over there. Here it posts to
// /api/auth/sign-in/social, the endpoint auth:api ported for exactly that client (U4).
export function GithubSignInButton({
  callbackURL,
  errorCallbackURL,
  label,
}: Props) {
  const [isLoading, setIsLoading] = useState(false);

  const handleGithubLogin = async () => {
    try {
      setIsLoading(true);
      const response = await fetch('/api/auth/sign-in/social', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          provider: 'github',
          callbackURL,
          errorCallbackURL,
        }),
      });
      const body = (await response.json()) as { url?: string };

      if (!body.url) {
        throw new Error('Sign-in failed');
      }

      window.location.href = body.url;
    } catch (error) {
      console.error(error);
      toast.error('Error al iniciar sesión con GitHub');
      setIsLoading(false);
    }
  };

  return (
    <Button
      onClick={handleGithubLogin}
      disabled={isLoading}
      size="lg"
      className="w-full"
    >
      <Github className="mr-2 h-5 w-5" />
      {isLoading ? 'Conectando...' : label}
    </Button>
  );
}
